'use client';

import React, { useCallback, useEffect, useRef, useState } from "react";
import ClientComponent from "./client_component";
import { AppBar, Box, Divider, IconButton, List, ListItem, ListItemText, Stack, Toolbar, Typography } from "@mui/material";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import BuilderSelct from "@/store/builderStoreSelector";
import { Project, RoomModel } from "@/store/builderSlice";
import RoomModelsList from "./RoomModelsList";
import { actions as builderActions } from "@/store/builderSlice";
import { useDispatch } from "react-redux";
import { BUILDER_SUCCESS } from "@/utils/builder/builderConstants";
import { isDesigner } from "@/utils/builder/featureCatalog";

const RoomModelsOverlay = () => {
    const dispatch = useDispatch();
    const roomModels: RoomModel[] = BuilderSelct.roomModels().models;
    const loadingStatus: string = BuilderSelct.roomModels().status;
    const project: Project = BuilderSelct.project();
    const urlParams: { [key: string]: string } = BuilderSelct.ui().urlParams;
    const isCustomRoomFlow: boolean = BuilderSelct.ui().isCustomRoomFlow;

    const [open, setOpen] = useState(true);
    const [activeRoomModel, setActiveRoomModel] = useState<RoomModel | null>(null);
    const isEditFlow = urlParams.projectId != null || urlParams.layoutId != null;
    const isShowCaseFlow = urlParams.showcase === 'true';
    const isDesignerFlow = isDesigner(urlParams.role);
    const loadRoomFromUrlRef = useRef(false);
    useEffect(() => {
        if (loadingStatus === BUILDER_SUCCESS) {
            const targetRoomId = isEditFlow ? project.roomModel.roomId : urlParams.roomId;
            const roomModel = roomModels.find(model => model.roomId === targetRoomId);
            if (!roomModel && isEditFlow)
                throw new Error('Room model not available');
            loadRoomFromUrlRef.current = roomModel != null;
            roomModel && dispatch(builderActions.updateRoomId({
                roomModel: {
                    roomId: roomModel.roomId,
                    model3DUrl: roomModel.glbUrl,
                    thumbnail: roomModel.thumbnail
                }
            }));
        }
    }, [loadingStatus]);

    const handleClose = () => {
        if (!activeRoomModel) return;
        dispatch(builderActions.setRoomLayoutFromModel({
            roomModel: activeRoomModel
        }));
        dispatch(builderActions.updateRoomId({
            roomModel: {
                roomId: activeRoomModel.roomId,
                model3DUrl: activeRoomModel.glbUrl,
                thumbnail: activeRoomModel.thumbnail
            }
        }));
        setOpen(false);
    };

    const onRoomModelSelected = useCallback((roomModel: RoomModel) => {
        setActiveRoomModel(roomModel);
    }, []);

    const roomModelsList = () => {
        const roomTypes = urlParams.roomType ?
            [urlParams.roomType] :
            ['Living Room', 'Bed Room', 'Dining Room', 'Bedroom', 'Home Office'];
        const modelListComps: JSX.Element[] = [];
        roomTypes.forEach(roomType => {
            const modelsByRoomType = roomModels.filter(roomModel =>
                roomModel.roomType && roomModel.roomType.toLowerCase() === roomType.toLowerCase()
            );
            if (modelsByRoomType.length > 0) {
                if (modelListComps.length > 0)
                    modelListComps.push(<Divider />);
                modelListComps.push(
                    <ListItem>
                        <RoomModelsList
                            models={modelsByRoomType}
                            onRoomModelSelected={onRoomModelSelected}
                            selectedRoomId={activeRoomModel?.roomId}
                        />
                    </ListItem>
                );
            }
        });
        return modelListComps;
    }

    if (isEditFlow || loadRoomFromUrlRef.current || isCustomRoomFlow || isShowCaseFlow) return <></>;

    return (
        <Dialog
            fullScreen
            open={open}
            onClose={handleClose}
        >
            <AppBar sx={{ position: 'relative' }}>
                <Toolbar sx={{ backgroundColor: '#808B96' }}>
                    <Typography sx={{ ml: 2, flex: 1 }} variant="h4" component="div">
                        Please select a room model
                    </Typography>
                    <Button disabled={!activeRoomModel} variant="contained" size="small" onClick={handleClose}>
                        {isDesignerFlow ? 'Design this room' : 'Personalize this room'}
                    </Button>
                </Toolbar>
            </AppBar>
            {loadingStatus === '' ?
                (<Box component={'div'}>
                    Loading your room models....
                </Box>) :
                (<List>
                    {roomModelsList()}
                </List>)
            }


        </Dialog>
    )
}

export default ClientComponent(RoomModelsOverlay);